const blockButtons = document.querySelectorAll('.js--card_toggle');
const ticketButtons = document.querySelectorAll('.js--card_ticket_toggle');

function handleResize() {
  const isWideScreen = window.innerWidth >= 992;
  blockButtons.forEach(button => {
    const settingsCard = button.closest('.js--card');

    if (isWideScreen) {
      settingsCard.style.maxHeight = '';
      // settingsCard.style.overflow = 'hidden';
      button.classList.remove('opened');
    } else if (!button.classList.contains('opened')) {
      settingsCard.style.maxHeight = '60px';
      settingsCard.style.overflow = 'hidden';
    }
  });
  ticketButtons.forEach(button => {
    const ticketCard = button.closest('.js--card-ticket');

    if (isWideScreen) {
      ticketCard.style.maxHeight = '';
      // settingsCard.style.overflow = 'hidden';
      button.classList.remove('opened');
    } else if (!button.classList.contains('opened')) {
      ticketCard.style.maxHeight = '30px';
      ticketCard.style.overflow = 'hidden';
    }
  });
}

if (blockButtons && blockButtons.length) {
  blockButtons.forEach(button => {
    button.addEventListener('click', function () {
      const settingsCard = this.closest('.js--card');

      if (settingsCard.style.maxHeight === '60px') {
        settingsCard.style.maxHeight = '';
        settingsCard.style.overflow = 'visible';
        this.classList.add('opened');
      } else {
        settingsCard.style.maxHeight = '60px';
        settingsCard.style.overflow = 'hidden';
        this.classList.remove('opened');
      }
    });
  });
}
if (ticketButtons && ticketButtons.length) {
  ticketButtons.forEach(ticketButton => {
    ticketButton.addEventListener('click', function () {
      const ticketCard = this.closest('.js--card-ticket');

      if (ticketCard.style.maxHeight === '30px') {
        ticketCard.style.maxHeight = '';
        ticketCard.style.overflow = 'visible';
        this.classList.add('opened');
      } else {
        ticketCard.style.maxHeight = '30px';
        ticketCard.style.overflow = 'hidden';
        this.classList.remove('opened');
      }
    });
  });
}

window.addEventListener('resize', handleResize);

handleResize();


document.addEventListener("DOMContentLoaded", function () {
  const radioButtons = document.querySelectorAll("input[name='bookkeeping']");
  const addressField = document.querySelector("input[name='document_send_address']");
  const edrpouField = document.querySelector("input[name='edrpou']");
  // const form = edrpouField.closest('form');
if (radioButtons && addressField && edrpouField) {
  function toggleAddressField() {
    const isChecked = document.querySelector("input[name='bookkeeping']:checked");
    addressField.readOnly = !(isChecked && isChecked.value === "3");
    edrpouField.readOnly = !(isChecked && isChecked.value === "3");
  }

  radioButtons.forEach(radio => {
    radio.addEventListener("change", toggleAddressField);
  });

  toggleAddressField();
}

});
